const experienceContent = [
  {
    year: 'aril-2025 - present',
    position: 'Full Stack Engineer',
    compnayName: 'Hubcom',
    details: `As a Full Stack Engineer I contribute to the end-to-end development of BURD (Bio User Recognition Data) an intelligent platform that combines facial recognition, activity monitoring, and real-time alerts to create safer, smarter environments. My responsibilities span the entire product lifecycle, including UI development, RESTful API design, and integration with backend services. I ensure performance optimization, security compliance, and scalability across the application stack. Leveraging the MERN stack and Next.js, I drive innovation through modular, maintainable code while collaborating with cross-functional teams to deliver robust, production ready features.
`,
  },
  {
    year: 'feb-2024 - march-2025',
    position: 'Software Engineer',
    compnayName: 'Strugbits pvt ltd',
    details: `As a Software Engineer specializing in the MERN Stack and Next.js, I develop scalable, high-performance full stack applications using MongoDB, Express.js, React, Node.js, and Next.js. With expertise in creating dynamic and responsive websites using WIX and WIX CMS, I deliver customized solutions that enhance user engagement and drive business growth. Passionate about research and development, I continuously explore cutting-edge technologies to integrate advanced features and optimize application performance.
`,
  },
  {
    year: 'aug-2022 - feb-2024',
    position: 'mern stack developer',
    compnayName: 'BawdicSoft pvt ltd',
    details: `As a MERN Stack Developer, I tackled diverse challenges across multiple projects, leveraging advanced technologies like React.js, Next.js, Node.js, Express.js, MongoDB, GraphQL, Firebase, Google Cloud Console, AWS and blockchain integration. My focus was on delivering robust, scalable solutions that met client needs and optimized performance.
`,
  },
  {
    year: 'feb-2022 - aug-2022',
    position: 'internship',
    compnayName: 'BawdicSoft pvt ltd',
    details: `As a MERN Stack Intern at BawdicSoft Pvt. Ltd, I contributed to the Web Development Unit by building and maintaining web applications using MongoDB, Express.js, React.js, and Node.js. Over the course of my 6-month internship, I gained hands-on experience in full-stack development, collaborating with teams to deliver scalable and efficient solutions.`,
  },
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
